import type { CSSProperties } from 'react';
import {
  ArrowSwitchIcon,
  CheckIcon,
  ChevronRightIcon,
  FileDirectoryIcon,
  FileIcon,
  HomeIcon,
  NoteIcon,
  TagIcon,
  KebabHorizontalIcon,
  GearIcon,
  MoonIcon,
  DashIcon,
  WorkflowIcon,
  OrganizationIcon,
  PlusIcon,
  SearchIcon,
  SignOutIcon,
  SunIcon,
  ThreeBarsIcon,
  XIcon,
  PlugIcon,
  TerminalIcon,
  CopyIcon,
  LinkExternalIcon,
  CloudOfflineIcon,
  AlertIcon,
  SyncIcon,
  // Category glyphs for the knowledge map. One icon family throughout, so a
  // category's icon reads as part of the product rather than as decoration.
  BookIcon,
  ChecklistIcon,
  LawIcon,
  ShieldIcon,
  BeakerIcon,
  BugIcon,
  BriefcaseIcon,
  CalendarIcon,
  MilestoneIcon,
  PackageIcon,
  CommentDiscussionIcon,
  DatabaseIcon,
  RocketIcon,
  PersonIcon,
  GlobeIcon,
  QuestionIcon,
} from '@primer/octicons-react';

// One product icon family. Named imports keep unused Octicons out of the build.
const icons = {
  search: SearchIcon,
  menu: ThreeBarsIcon,
  close: XIcon,
  plus: PlusIcon,
  chevron: ChevronRightIcon,
  switch: ArrowSwitchIcon,
  overview: HomeIcon,
  organization: OrganizationIcon,
  graph: WorkflowIcon,
  minus: DashIcon,
  file: FileIcon,
  folder: FileDirectoryIcon,
  check: CheckIcon,
  logout: SignOutIcon,
  moon: MoonIcon,
  sun: SunIcon,
  notes: NoteIcon,
  tag: TagIcon,
  more: KebabHorizontalIcon,
  settings: GearIcon,
  plug: PlugIcon,
  terminal: TerminalIcon,
  copy: CopyIcon,
  external: LinkExternalIcon,
  cloudOffline: CloudOfflineIcon,
  alert: AlertIcon,
  sync: SyncIcon,
  book: BookIcon,
  checklist: ChecklistIcon,
  law: LawIcon,
  shield: ShieldIcon,
  beaker: BeakerIcon,
  bug: BugIcon,
  briefcase: BriefcaseIcon,
  calendar: CalendarIcon,
  milestone: MilestoneIcon,
  package: PackageIcon,
  discussion: CommentDiscussionIcon,
  database: DatabaseIcon,
  rocket: RocketIcon,
  person: PersonIcon,
  globe: GlobeIcon,
  question: QuestionIcon,
  note: NoteIcon,
  workflow: WorkflowIcon,
} as const;

/** The icon names a map category may use, for the style editor's picker. */
export type IconName = keyof typeof icons;

export function Icon({
  name,
  size = 16,
  style,
}: {
  name: keyof typeof icons;
  size?: number;
  style?: CSSProperties;
}) {
  const Glyph = icons[name];
  return (
    <span className="icon" style={style} aria-hidden="true">
      <Glyph size={size} />
    </span>
  );
}
